import script from "./UpdateComp.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateComp.vue?vue&type=script&setup=true&lang=js"

import "./UpdateComp.vue?vue&type=style&index=0&id=1f134dc3&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f134dc3"]])

export default __exports__